<script>
  import {getContext, onMount} from 'svelte';
  import {IMAGES_NEWS} from '@/const/images';
  import Button from '@/widgets/Button.svelte';
  import lang from '../RegisterPage.lang';
  import {getRedirectTarget, clearRedirectTarget, isValidRedirectTarget} from '@/modules/header/util';

  const LG = getContext('LG');

  onMount(() => {
    setTimeout(() => {
      gotoTarget();
    }, 5000);
  });

  function gotoTarget() {
    const {target} = getRedirectTarget();
    window.location.assign(`${target}?doneConnect=1`);
  }

  function handlerClickContinue() {
    gotoTarget();
  }
</script>

<div class="register-success tc p24">
  <img width="80" src={IMAGES_NEWS.SUCCESS_ICON} alt="Success" />
  <div class="mt20 mb20 f16 fw3 T1">{LG(lang.ConnectRegisterSuccess)}</div>
  <div class="mb40 f14 T3">{LG(lang.ConnectRegisterSuccessDesc)}</div>
  <Button minWidth="100%" type="primary" on:click={handlerClickContinue}>{LG(lang.ContinueBtn)}</Button>
</div>
